<div class="card"></div>

<div class="card border-secondary mb-6" style="max-width: 100%;">
  <div class="card-header">QueryParameter</div>
  <div class="card-body text-secondary">
    <h4 class="card-title">クエリパラメータを扱うサンプル</h4>
    <div class="card-text">
      <p>
        クエリパラメータ付きで遷移した場合はその値が'Count:
        100'といった形で表示される
      </p>
      <p>
        ボタンでインクリメントした場合、URLの`count`パラメータの値もインクリメントする
      </p>
    </div>
  </div>
</div>

<div class="dropdown-divider"></div>
<div>
  <button (click)="countUp()" class="btn btn-sm btn-primary">Count UP</button>
</div>

<div>
  Count: <span class="text-info">{{ count }}</span>
</div>
